var FontSizes;
(function (FontSizes) {
    FontSizes["large"] = "1.875rem";
    FontSizes["body"] = "1rem";
})(FontSizes || (FontSizes = {}));
export default FontSizes;
export const createCustomFontSize = (multiplier) => `${multiplier}rem`;
